import React from "react";
import { ReferenceField, ShowProps, TextField } from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import CustomLabeled from "../../components/layout/CustomLabeled";
import WaveField from "./components/WaveField";

const Summary = (_props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Adhoc Operator Detail
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Route Plan Wave">
            <WaveField />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Route Name">
            <ReferenceField source="routeId" reference="routes">
              <TextField source="name" />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Replacement Date">
            <CustomDateField source="date" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item md={3} xs={12}>
          <CustomLabeled name="Driver">
            <ReferenceField source="driverId" reference="drivers" emptyText="-">
              <TextField source="fullName" />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item md={3} xs={12}>
          <CustomLabeled name="Bus Assistant">
            <ReferenceField
              source="busAssistantId"
              reference="busAssistants"
              emptyText="-"
            >
              <TextField source="fullName" />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item md={6} xs={12}></Grid>

        <Grid item md={3} xs={12}>
          <CustomLabeled name="Subcontractor">
            <ReferenceField
              source="subcontractorId"
              reference="subcontractors"
              emptyText="-"
            >
              <TextField source="name" />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item md={9} xs={12}></Grid>

        <Grid item md={3} xs={12}>
          <CustomLabeled name="Remark">
            <TextField source="remark" />
          </CustomLabeled>
        </Grid>
        <Grid item md={9} xs={12}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
